/**
 * Plugin Name: LT Analytics
 * Description: a plugin to include tracking analytics on lendingtree.com
 */

// ==================================Track-visit============================================================
const queryParams = window.ltReferrerTrack && window.ltReferrerTrack.get(),
    LtTrackingConfig = LT_TRACKING_CONFIG; // eslint-disable-line
let recommendationID = '';

if (queryParams && typeof queryParams === 'object') {
    if (queryParams.ltwarea || queryParams.ltwpos || queryParams.ltwpid) {
        recommendationID = `${queryParams.ltwpid}:${queryParams.ltwarea}:${LtTrackingConfig.currentId}:${queryParams.ltwpos}`;
    }
}

if (window.ltanalytics) {
    window.ltanalytics.page(location.pathname, {
        path: location.pathname,
        isNonProd: LtTrackingConfig.ltanalyticsIsNonprod,
        recommendationids_clicked: recommendationID,
        isAuthenticated: (function (k) { return new RegExp(`(^|; )${k}=([^;]*)`).test(document.cookie); }('ajs_is_fcs')),
        isFreeCreditScore: (function (k) { return (document.cookie.match(`(^|; )${k}=([^;]*)`) || 0)[2]; }('ajs_is_fcs')) || '',
        page_intended_product: LtTrackingConfig.pageIntendedProduct,
        ltnav: typeof queryParams !== 'object' ? queryParams : null,
        pageTemplate: LtTrackingConfig.pageTemplate,
    });
}

function receiveStatus(event) {
    if (event.data && event.data.TreeAuthUid) {
        window.ltanalytics = window.ltanalytics || [];
        window.ltanalytics.push(function() { // eslint-disable-line
            if (window.adobe && window.adobe.target && window.adobe.target.getOffers) {
                window.adobe.target.getOffers({
                    request: {
                        id: {
                            thirdPartyId: event.data.TreeAuthUid,
                        },
                        prefetch: {
                            mboxes: [{
                                index: 0,
                                name: 'mbox3rdparty-data',
                                profileParameters: {
                                    id: event.data.TreeAuthUid,
                                },
                            }],
                        },
                    },
                });
            }
        });
    }
}

window.addEventListener('message', receiveStatus, false);

// ==================================Track-visit-end============================================================


// WEBPACK FOOTER //
// ./scripts/analytics-tracking.js